<template>
    <div class="esi" :class="{'esi--invisible': !visible}">

        <input class="esi__input"
               :name="getName"
               :class="{
            'esi__input--invisible': !visible,
            'esi__input--valid': valid,
            'esi__input--error': error,
            'esi__input-dark': darkTheme
            }"
               ref="input"
               :type="type"
               :value="value"
               @focus="focus()"
               @blur="blur()"
               @input="emit()"
               @keyup="keyup()"
               v-validate="validation">

        <label class="esi__label"
               :class="{
               'esi__label--focus': focus,
               'esi__label--filled': value.length,
               'esi__label--valid': valid,
               'esi__label--error': error,
               'esi__label--invisible': hideLabel
               }"
               v-if="label">{{ label }}</label>
    </div>

</template>

<script>
  import { VueMaskDirective } from 'v-mask'

  export default {
    name: "EdaStyledInput",
    inject: ['$validator'],
    directives: { 'mask': VueMaskDirective },
    props: {
      type: { type: String, default: "text" },
      label: { type: String, default: "" },
      value: { type: String, default: "" },
      name: { type: String, default: "" },
      keepLabel: { type: Boolean, default: true },
      visible: { type: Boolean, default: true },
      inputMask: { type: String, default: "" },
      darkTheme: { type: Boolean, default: false },
      validation: { type: String, default: null }

    },
    data() {
      return {
        focused: false,
      }
    },
    methods: {
      emit() {
        this.$emit('input', this.$refs.input.value)
      },
      focus() {
        this.focused = true;
        this.$emit('focus')
      },
      blur() {
        this.focused = false;
        this.$emit('blur')
      },
      keyup() {
        this.$emit('keyup')
      }
    },
    computed: {
      getName() {
        return this.name.length ? this.name : this.label;
      },
      error() {
        return this.errors.has(this.name) && !this.focused;
      },
      valid() {
        return !this.errors.has(this.name) && this.value.length;
      },
      hideLabel() {
        return this.focused && !this.keepLabel;
      }

    }
  }
</script>

<style lang="scss">
    .esi {
        position: relative;
        border-radius: 2em;
        overflow: hidden;
        max-height: 4em;
        transition: all 0.2s cubic-bezier(.5, 0, 0, 1);
    }

    .esi--invisible {
        max-height: 0;
    }

    .esi__input {
        padding: 1em 1.5em;
        background-color: #EEE;
        border-radius: 2em;
        width: 100%;
        margin: 0.3em 0;
        border: none;
        max-height: 3em;
        opacity: 1;
        font-size: 1em;
        -webkit-appearance: none;
        outline: none;
        transition: all 0.2s cubic-bezier(.5, 0, 0, 1);
    }

    .esi__input-dark {
        background-color: #0d1a0f;
        color: #EFEFEF;

    }

    .esi__input--valid {
    }

    .esi__input--error {
        background-color: #ffe9e2;
        color: #920000;
    }

    .esi__input--invisible {
        max-height: 0em;
        padding: 0 1.5em;
        opacity: 0;
        margin: 0;
    }

    .esi__label {
        pointer-events: none;
        position: absolute;
        top: 50%;
        color: #AAA;
        font-size: 0.9em;
        font-weight: 300;
        width: 100%;
        text-align: left;
        left: 2em;
        transform: translate(0, -50%);

        &--invisible {
            display: none;
        }
    }

    .esi__label--filled,
    .esi__label--focus {
        display: block;
        transition: all 0.2s cubic-bezier(.5, 0, 0, 1);
        animation: comearound 0.2s forwards;
        word-break: keep-all;
        text-align: right;
        padding-right: 3em;
    }

    .esi__label--filled {
        color: #CCC;
    }

    .esi__label--focus {
        color: #00B27C;
    }

    .esi__label--error {
        color: red;
    }

    @keyframes comearound {
        0% {
            opacity: 0;
            left: 0%;
            transform: translate(0%, -50%);
        }
        25% {
            left: 0%;
            transform: translate(-150%, -50%);
        }
        50% {
            left: 100%;
            opacity: 0;
            transform: translate(150%, -50%);
        }
        100% {
            left: 100%;
            transform: translate(-100%, -50%);
        }
    }


</style>